module.exports = __webpack_public_path__ + "static/img/Isaah-Yeo.4b3c3be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Isaah-Yeo.jpg
// module id = LvQ8
// module chunks = 0